import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "./config";

const links = [
  { label: "Services", id: "services" },
  { label: "Flotte", id: "flotte" },
  { label: "Avis", id: "avis" },
  { label: "Zone", id: "zone" },
  { label: "Contact", id: "contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-baseline gap-2 group">
          <span className="font-serif text-3xl leading-none tracking-tight text-blush">MN</span>
          <span className="text-[0.6rem] tracking-[0.4em] text-rose transition-colors">VTC</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs uppercase tracking-[0.18em] text-muted-foreground hover:text-blush transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="nav-call-cta"
          href={CONTACT.phoneHref}
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-rose px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-white hover:bg-rose-dark transition-colors"
        >
          <Phone size={14} /> {CONTACT.phoneDisplay}
        </a>

        <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="md:hidden text-blush">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-ink/95 backdrop-blur-xl border-t border-white/5"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button key={l.id} data-testid={`mobile-nav-${l.id}`} onClick={() => go(l.id)} className="text-left text-sm uppercase tracking-[0.18em] text-blush">
                  {l.label}
                </button>
              ))}
              <a href={CONTACT.phoneHref} className="mt-2 inline-flex items-center gap-2 rounded-full bg-rose px-5 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-white w-fit">
                <Phone size={14} /> {CONTACT.phoneDisplay}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Nav;
